var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,62 C0,27.7583455 27.7583455,0 62,0 C96.2416545,0 124,27.7583455 124,62 C124,96.2416545 96.2416545,124 62,124 C27.7583455,124 0,96.2416545 0,62 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-59.7%",
    y: "-45.2%",
    width: "219.4%",
    height: "221.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 20,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.043672883   0 0 0 0 0.781702899   0 0 0 0 0.389059963  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter2",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contractor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rule-2",
    transform: "translate(-39.000000, -39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "accept-path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#FFFFFF",
    strokeWidth: 8,
    fill: "none",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(43.000000, 43.000000)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 37.9491293,
    y1: 0,
    x2: 0,
    y2: 37.9491293,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.9491293,
    y1: 0,
    x2: 0,
    y2: 37.9491293,
    id: "Path-Copy",
    transform: "translate(18.974565, 18.974565) scale(-1, 1) translate(-18.974565, -18.974565) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.acc54792a8b7e00c4fb4596f25366afc.svg";
export { ForwardRef as ReactComponent };